module.exports = __webpack_public_path__ + "img/click-allow.52c8dacb.png";